<block-ui>
    <router-outlet></router-outlet>
</block-ui>